
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/integrations/blue-yonder",
      function () {
        return require("private-next-pages/integrations/blue-yonder.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/integrations/blue-yonder"])
      });
    }
  